// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e783d510","64":"32eb4f79","84":"775d66c3","112":"8150f9c0","233":"9f58629f","411":"887081a0","516":"5fa16ffa","531":"9a38327d","616":"9ae45c3f","629":"a30b3020","636":"44fff91c","787":"79754a34","895":"2d68ff23"}[chunkId] + ".chunk.js";
};